import { render, staticRenderFns } from "./MainDashboard.vue?vue&type=template&id=292a62ee&scoped=true&"
import script from "./MainDashboard.vue?vue&type=script&lang=js&"
export * from "./MainDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MainDashboard.vue?vue&type=style&index=0&id=292a62ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292a62ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VSlideYTransition})
